import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class ArchiveApproveItemApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'archive-approve-item'
    }


    /**
     * 修改阅读状态
     * @param params 
     * @returns 
     */
    public updateItem(params) {
        return this.send(params, "updateItem", this.Methods.POST)
    }

    /**
     * 获取审批信息
     * @param params 
     * @returns 
     */
    public getApproveList(params) {
        return this.send(params, "getApproveList", this.Methods.GET)
    }







}